import { __extends } from "tslib";
import { MethodBase, _Shader_MethodBase } from './MethodBase';
/**
 * EffectColorTransformMethod provides a shading method that changes the colour of a material analogous to a
 * ColorTransform object.
 */
var EffectColorTransformMethod = /** @class */ (function (_super) {
    __extends(EffectColorTransformMethod, _super);
    /**
     * Creates a new EffectColorTransformMethod.
     */
    function EffectColorTransformMethod(colorTransform) {
        if (colorTransform === void 0) { colorTransform = null; }
        var _this = _super.call(this) || this;
        _this._colorTransform = colorTransform;
        return _this;
    }
    Object.defineProperty(EffectColorTransformMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return EffectColorTransformMethod.assetType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EffectColorTransformMethod.prototype, "colorTransform", {
        /**
         * The ColorTransform object to transform the colour of the material with.
         */
        get: function () {
            return this._colorTransform;
        },
        set: function (value) {
            this._colorTransform = value;
            this.invalidate();
        },
        enumerable: false,
        configurable: true
    });
    EffectColorTransformMethod.assetType = '[asset EffectColorTransformMethod]';
    return EffectColorTransformMethod;
}(MethodBase));
export { EffectColorTransformMethod };
import { ShaderBase } from '@awayjs/renderer';
/**
 * EffectColorTransformChumk provides a shading method that changes the colour of a material analogous to a
 * ColorTransform object.
 */
var _Shader_EffectColorTransformMethod = /** @class */ (function (_super) {
    __extends(_Shader_EffectColorTransformMethod, _super);
    /**
     * Creates a new EffectColorTransformChumk.
     */
    function _Shader_EffectColorTransformMethod(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    /**
     * @inheritDoc
     */
    _Shader_EffectColorTransformMethod.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = '';
        var colorMultReg = registerCache.getFreeFragmentConstant();
        var colorOffsReg = registerCache.getFreeFragmentConstant();
        this._colorTransformIndex = colorMultReg.index * 4;
        //TODO: AGAL <> GLSL
        code += 'mul ' + targetReg + ', ' + targetReg + ', ' + colorMultReg + '\n' +
            'add ' + targetReg + ', ' + targetReg + ', ' + colorOffsReg + '\n';
        return code;
    };
    /**
     * @inheritDoc
     */
    _Shader_EffectColorTransformMethod.prototype._activate = function () {
        if (this._invalid) {
            var index = this._colorTransformIndex;
            var data = this._shader.fragmentConstantData;
            var rawData = this._method.colorTransform._rawData;
            data[index] = rawData[0];
            data[index + 1] = rawData[1];
            data[index + 2] = rawData[2];
            data[index + 3] = rawData[3];
            data[index + 4] = rawData[4];
            data[index + 5] = rawData[5];
            data[index + 6] = rawData[6];
            data[index + 7] = rawData[7];
        }
    };
    return _Shader_EffectColorTransformMethod;
}(_Shader_MethodBase));
export { _Shader_EffectColorTransformMethod };
ShaderBase.registerAbstraction(_Shader_EffectColorTransformMethod, EffectColorTransformMethod);
